// extracted by mini-css-extract-plugin
export var borderRadius = "_gj-4";
export var large = "_gj-3";
export var logoContainer = "_gj-0";
export var nameLogo = "_gj-2";
export var small = "_gj-1";